import { Minus, Plus, RotateCcw } from "lucide-react";
import { useState, type WheelEvent } from "react";
import { layouts } from "../data";
import { useConfiguratorStore } from "../store";

export function FloorPlanViewer() {
  const configuration = useConfiguratorStore((state) => state.configuration);
  const layout = layouts.find((item) => item.id === configuration.layoutId) ?? layouts[0];
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragStart, setDragStart] = useState<{ x: number; y: number } | null>(null);

  const reset = () => {
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const onWheel = (event: WheelEvent) => {
    event.preventDefault();
    setZoom((current) => Math.min(2.4, Math.max(0.75, current - event.deltaY * 0.001)));
  };

  return (
    <div
      className="floor-plan-viewer"
      onWheel={onWheel}
      onPointerDown={(event) => {
        event.currentTarget.setPointerCapture(event.pointerId);
        setDragStart({ x: event.clientX - position.x, y: event.clientY - position.y });
      }}
      onPointerMove={(event) => {
        if (dragStart) setPosition({ x: event.clientX - dragStart.x, y: event.clientY - dragStart.y });
      }}
      onPointerUp={() => setDragStart(null)}
      onPointerCancel={() => setDragStart(null)}
    >
      <div className="plan-meta">
        <span>{layout.name} · {configuration.areaM2} m²</span>
        <small>1:100 · Nord ↑</small>
      </div>
      <div
        className="plan-sheet"
        style={{ transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})` }}
      >
        <img
          src={`/floorplans/${configuration.layoutId}.svg?v=3`}
          alt={`Plantegning ${layout.name} med ${layout.bedrooms} værelser og ${layout.bathrooms} badeværelser`}
          draggable={false}
        />
      </div>
      <div className="floorplan-controls">
        <button type="button" aria-label="Zoom ud" onClick={() => setZoom((value) => Math.max(0.75, value - 0.2))}><Minus size={17} /></button>
        <span>{Math.round(zoom * 100)}%</span>
        <button type="button" aria-label="Zoom ind" onClick={() => setZoom((value) => Math.min(2.4, value + 0.2))}><Plus size={17} /></button>
        <button type="button" aria-label="Nulstil plantegning" onClick={reset}><RotateCcw size={16} /></button>
      </div>
    </div>
  );
}
